import React from 'react';

interface LineCalendarIconProps {
  size?: number;
  color?: string;
}

export const LineCalendarIcon: React.FC<LineCalendarIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="4" width="18" height="17" rx="2" stroke={color} strokeWidth="2" />
      <rect x="7" y="1" width="2" height="6" rx="1" fill={color} />
      <rect x="2" y="9" width="20" height="2" rx="1" fill={color} />
      <rect x="15" y="1" width="2" height="6" rx="1" fill={color} />
    </svg>
  );
};
